module.exports = __webpack_public_path__ + "static/img/siteTipImg.36089069.png";